// extracted by mini-css-extract-plugin
module.exports = {"default":"input_default__2sJdE","card":"input_card__3SHtr","small":"input_small__1p9wa","smallFirst":"input_smallFirst__2EIXb"};